import(/* webpackMode: "eager" */ "/codebuild/output/src3195297680/src/remandate-front-end/app/page.js");
